import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon} from './Icon'

type CloseCircleIconProps = {
  backgroundColor?: string
  iconColor?: string
  size?: IconSize
}

export const CloseCircleIcon: FC<CloseCircleIconProps> = ({
  backgroundColor = theme.palette.secondary.main,
  iconColor = theme.palette.primary.main,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 10C0 4.47714 4.47714 0 10 0C15.5229 0 20 4.47714 20 10C20 15.5229 15.5229 20 10 20C4.47714 20 0 15.5229 0 10Z"
          fill={backgroundColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.21967 6.21968C6.51256 5.92677 6.98744 5.92677 7.28033 6.21968L10 8.93936L12.7197 6.21968C13.0126 5.92677 13.4874 5.92677 13.7803 6.21968C14.0732 6.51257 14.0732 6.98744 13.7803 7.28034L11.0607 10L13.7803 12.7197C14.0732 13.0126 14.0732 13.4875 13.7803 13.7803C13.4874 14.0732 13.0126 14.0732 12.7197 13.7803L10 11.0607L7.28033 13.7803C6.98744 14.0732 6.51256 14.0732 6.21967 13.7803C5.92678 13.4875 5.92678 13.0126 6.21967 12.7197L8.93935 10L6.21967 7.28034C5.92678 6.98744 5.92678 6.51257 6.21967 6.21968Z"
          fill={iconColor}
        />
      </svg>
    </Icon>
  </>
)
